// English strings (source language): activity list.

const en = {
  title: 'Activities',
  intro: 'Every ride is recorded second by second and can be exported as TCX (Strava, Garmin Connect, intervals.icu).',
  filters: { all: 'All', race: 'Races', online: 'Online', workout: 'Workouts' },
  activities: 'Activities',
  totalTime: 'Total time',
  distance: 'Distance',
  energy: 'Energy',
  cols: { activity: 'Activity', date: 'Date', duration: 'Duration', distance: 'Distance', avg: 'Avg', np: 'NP', tss: 'TSS', result: 'Result', xp: 'XP' },
  empty: 'No activities yet.',
};
export default en;
